var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#072C54",
  strokeWidth: 1.5,
  d: "M10.166 8V4M20.4 6h-10M8 6H4m6.166 14v-4M20.4 18h-10M8 18H4m10.234-4v-4M4 12h10m2.4 0h4"
})));
export { SvgFilter as ReactComponent };
export default "/_next/static/images/filter.svg";